import {FontColorType} from "../plugins/highlight/font-color/font-color-plugin";
import {BadgeType} from "../plugins/highlight/badge/badge-plugin";

export function lexicalGetColorNumber(colorStyleType: any) {
    let colorNumber = null
    switch (colorStyleType) {
        case FontColorType.LIGHT_BLUE   :
        case BadgeType.LIGHT_BLUE       : colorNumber = 6; break
        case FontColorType.DARK_BLUE    :
        case BadgeType.DARK_BLUE        : colorNumber = 20; break
        case FontColorType.GREEN        :
        case BadgeType.GREEN            : colorNumber = 10; break
        case FontColorType.YELLOW       :
        case BadgeType.YELLOW           : colorNumber = 14; break
        case FontColorType.ORANGE       :
        case BadgeType.ORANGE           : colorNumber = 15; break
        case FontColorType.RED          :
        case BadgeType.RED              : colorNumber = 16; break
        case FontColorType.MAGENTA      :
        case BadgeType.MAGENTA          : colorNumber = 3; break
        case FontColorType.PURPLE       :
        case BadgeType.PURPLE           : colorNumber = 4; break
        case FontColorType.BROWN        :
        case BadgeType.BROWN            : colorNumber = 19; break
        case FontColorType.GRAY         :
        case BadgeType.GRAY             : colorNumber = 0; break
    }

    return colorNumber
}